<script lang="ts">
	import type { MyBadgesQuery } from "$gql/generated";
	import BadgeDetails from "./BadgeDetails.svelte";

	export let badge: MyBadgesQuery["me"]["badges"][0];
	export let active = true;
	export let badgeSize = "default";

	$: bWidth = (badgeSize === "medium" ? 66 : 37) + "px";
	$: bHeight = (badgeSize === "medium" ? 73.84 : 41.66) + "px";
</script>

<div
	class="nx-badge relative bg-contain bg-center bg-no-repeat"
	style="--b-width: {bWidth}; --b-height: {bHeight}; background-image: url({active ? badge.urls.image : badge.urls.grayImage})">
	<div class="badge-tip invisible absolute z-10 opacity-0 transition-all">
		<div class="chevron absolute z-20 border-l border-t bg-white" />
		<div class="details absolute rounded border bg-white p-4 shadow">
			<BadgeDetails {badge} />
		</div>
	</div>
</div>

<style>
	.nx-badge {
		width: var(--b-width, 78px);
		height: var(--b-height, 87px);
	}
	.nx-badge:hover .badge-tip {
		transition-delay: 300ms;
		visibility: visible;
		opacity: 1;
	}
	.badge-tip {
		width: 400px;
		top: 80%;
		left: calc((var(--b-width) - 400px) / 2);
		/* -161px; (width of .badge-tip/2) - (width of .nx-badge/2) */
	}
	.chevron {
		width: 20px;
		height: 20px;
		transform: rotate(45deg);
		left: calc(50% - 10px);
	}
	.details {
		top: 10px;
	}
</style>
